import React from 'react';
import './App.css';
import Home from './components/Home';
import Contact from './components/Contact';
import About from './components/About';

function App() {
  return (
    <div className="App">
      <header className="header" id="header">5
        <a href="#home" className="logo-container">
            <div className="logo">
            {
                /*
                <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                    <defs>
                        <linearGradient id="grad1" x1="0%" y1="0%" x2="100%" y2="100%">
                            <stop offset="0%" stop-color="#667eea" stop-opacity={1} />
                            <stop offset="100%" stop-color="#764ba2" stop-opacity={1} />
                        </linearGradient>
                    </defs>
                    <rect x="10" y="25" width="15" height="50" fill="url(#grad1)" transform="rotate(-15 17.5 50)" />
                    <rect x="35" y="15" width="15" height="70" fill="url(#grad1)" />
                    <rect x="60" y="25" width="15" height="50" fill="url(#grad1)" transform="rotate(15 67.5 50)" />
                    <circle cx="50" cy="50" r="45" fill="none" stroke="url(#grad1)" stroke-width="2" opacity="0.5" />
                </svg>
                */
            }
                <svg viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="60" cy="60" r="55" fill="none" stroke="#00FFFF" stroke-width="2" opacity="0.4" />
                    <rect x="30" y="30" width="15" height="60" fill="#00FFFF" rx="2" />
                    <rect x="45" y="30" width="30" height="15" fill="#00FFFF" rx="2" />
                    <rect x="45" y="75" width="30" height="15" fill="#00FFFF" rx="2" />
                    <rect x="75" y="45" width="15" height="30" fill="#00FFFF" rx="2" />

                    <rect x="70" y="70" width="10" height="2" fill="#00FFFF" transform="rotate(45 75 75)" />

                    <circle cx="20" cy="20" r="1.5" fill="#00FFFF" />
                    <circle cx="100" cy="20" r="1.5" fill="#00FFFF" />
                    <circle cx="20" cy="100" r="1.5" fill="#00FFFF" />
                    <circle cx="100" cy="100" r="1.5" fill="#00FFFF" />

                    <text x="60" y="110" font-size="10" text-anchor="middle" fill="#00FFFF" font-family="Arial, sans-serif">
                        Q-RUNNERS LED
                    </text>
                </svg>
            </div>
            <div className="logo-text">Q-Runners LED Display</div>
        </a>
        
        <nav className="main-menu" id="mainMenu">
            <a href="#home" className="menu-item active">Home</a>
            <a href="#about" className="menu-item">About</a>
            <a href="#contact" className="menu-item">Contact</a>
        </nav>
        
        <div className='menu-container'>
            <div className="menu-toggle" id="menuToggle">
                <span></span>
                <span></span>
                <span></span>
            </div>
            <nav className="dropdown-menu">
            <ul>
                <li><a href="#home" className='menu-item active'>Home</a></li>
                <li><a href="#about" className='menu-item'>About</a></li>
                <li><a href="#contact" className='menu-item'>Contact</a></li>
            </ul>
            </nav>
        </div>
      </header>
        <Home/>
        <About/>
        <Contact/>
      {/*<!-- Footer -->*/}
      <footer className="footer">
          <div className="footer-content">
              <div className="footer-copyright">
                  © 2025 Q-Runners LED. All rights reserved. | Designed by <a href="#" target="_blank" rel="noopener noreferrer">q-runners.com</a>
              </div>
          </div>
      </footer>

      {/*<!-- Scroll to top button -->*/}
      <div className="scroll-to-top" id="scrollToTop">
          <span>↑</span>
      </div>
    </div>
  );
}

export default App;
